import './index.css';
import img2 from '../../../src/images/cross-icon.svg'

export default function InsightsPage() {
    return (
        <div className="dashboard_container ai-analysis-container">
            <div className='patient-navbar'>
                <div></div>
                <div className='patient-icon'><span>AI Insights & Recommendations</span></div>
                <div><img src={img2} alt="" /></div>
            </div>
            <div className='patient_info_card'>
                <div className='patient_info_content'>
                    <div>
                        <h3>Victor Borg</h3>
                        <h4>Age 31, Type 1 Diabetes</h4>
                    </div>
                </div>
                <div className='ai-analysis-wrapper patient_buttons'>
                    <div className='aianalysis-btn3'><button>Call</button></div>
                    <div className='aianalysis-btn3'><button>SMS</button></div>
                </div>
            </div>
            <div className='bottom-line-insights'></div>
            <div className='summary-text'>
                <h2>Summary of Key Metrics</h2>
                <p>- Average Glucose: 145 mg/dL (current month)<br /> &nbsp;&nbsp;&nbsp;— Trend: 7 mg/dL improvement<br />
                    - Time in Range: 68% (target: 70%)<br />
                    - Hypoglycemic Episodes: 3 in the past week<br />
                    - Hyperglycemic Episodes: 4 in the past week<br />
                    - Daily Insulin Usage: 24 units basal, 16 units bolus</p>
            </div>
            <div className='insights_content'>
                <h2>2. Time in Range (TIR)</h2>
                <p>Current TIR: 68%, slightly below the target of 70%.<br /><br />
                    Recommendation: Consider a modest increase in basal insulin for late afternoon to reduce pre-dinner spikes, aiming to bring TIR closer to target.<br /><br />
                    Next Steps: Adjust Afternoon Basal Insulin</p>
            </div>
            <div className='insights_content'>
                <h2>3. Hypoglycemia</h2>
                <p>Hypoglycemia: Linked to weekend exercise sessions.
                    <br /><br />
                    Hyperglycemia: Most frequent after dinner.
                    <br /><br />
                    Recommendation: Encourage Victor to have a 15g carb snack before exercise to prevent lows. Evaluate dinner bolus timing for more effective glucose control.
                    <br /><br />
                    Next Steps: Recommend Pre-Exercise Snack and Review Evening Bolus Timing</p>
            </div>
            <div className='insights_content'>
                <h2>4. Insulin Usage Patterns</h2>
                <p>Current Dosage Balance: Basal 24 units, Bolus 16 units — balanced, but small adjustments suggested.
                    <br /><br />
                    Recommendation: Decrease morning basal by 1–2 units and increase pre-lunch bolus to reduce mid-day glucose peaks.
                    <br /><br />
                    Next Steps: Modify Basal & Bolus Doses</p>
            </div>
            <div className='insights_content'>
                <h2>5. Exercise and Meal Impacts</h2>
                <p>Exercise Impact: Notable drop in glucose after exercise, especially on weekends.
                    <br /><br />
                    Meal Impact: Glucose spikes observed post-lunch and dinner.
                    <br /><br />
                    Recommendation: Work with Victor to refine pre-meal insulin and review carbohydrate ratios, particularly for dinner.
                    <br /><br />
                    Next Steps: Carbohydrate Ratio Review
                    </p>
            </div>
            <div className='insights_content'>
                <h2>6. Diet Balance</h2>
                <p>Observation: Current diet may cause variability in glucose control. 
                    <br /><br />
                    Recommendation: Suggest more low-glycemic foods to stabilize glucose levels and refer Victor to a dietitian for ongoing support.
                    <br /><br />
                    Next Steps: Dietitian Referral for long-term dietary adjustments.
                    </p>
            </div>
        </div> 
    ); 
}
